import React, { ComponentProps } from "react";
import { useTranslation } from "react-i18next";
import { Paper, FormControl, InputLabel, Skeleton } from "@mui/material";
import Typography from "@common/components/Typography";

interface TicketCountProps {
  priority: TicketsPriorityFilter;
  count?: number;
  loading: boolean;
}

const labels: Record<TicketsPriorityFilter, string> = {
  Informational: "Informational",
  Critical: "Critical",
  Major: "Major",
  Minor: "Minor",
};

const typographyProps: ComponentProps<typeof Typography> = {
  realTime: true,
  align: "right",
  size: "bigger",
};

const TicketCount = (props: TicketCountProps) => {
  const { priority, count, loading } = props;
  const { t } = useTranslation();

  const ticketCount = (
    <Paper
      sx={(theme) => ({
        paddingRight: theme.spacing(1),
        paddingLeft: theme.spacing(1),
        borderRadius: theme.spacing(1),
      })}
    >
      <Typography {...typographyProps}>{count}</Typography>
    </Paper>
  );

  return (
    <FormControl margin="normal" sx={{ width: "100%" }}>
      <InputLabel
        shrink
        sx={(theme) => ({ color: theme.palette.ticket[priority].main })}
      >
        {t(labels[priority])}
      </InputLabel>

      {!loading && count !== undefined ? (
        ticketCount
      ) : (
        <Skeleton
          height={"100%"}
          width={"100%"}
          sx={{
            transform: "none",
            minHeight: "100%",
            borderRadius: (theme) => theme.spacing(0.5),
          }}
        >
          <Typography {...typographyProps}>-</Typography>
        </Skeleton>
      )}
    </FormControl>
  );
};

export default TicketCount;
